import { Controller } from "stimulus";
import {getState, setState} from './../search_results/state'

window.activeMenuController = null;

export default class extends Controller {

  // Time shield to prevent 'ghost' map clicks that can happen on some mobile devices when
  // a text box gains or loses focus.
  shieldsUp = false
  shieldTimeout = null



  connect() {
    window.activeMenuController = this
  }

  disconnect() {
    window.activeMenuController = null
  }

  toggleColorSelection(evt) {
    evt.preventDefault()
    if ($('.drawnShapeColorToggle').hasClass('flexicon-90')) {
      $('.drawnShapeColorToggle').removeClass('flexicon-90').addClass('flexicon-270')
      $('#colorChoices').removeClass('hidden')
    } else {
      $('#colorChoices').addClass('hidden')
      $('.drawnShapeColorToggle').removeClass('flexicon-270').addClass('flexicon-90')
    }
  }

  selectColor(evt) {
    evt.preventDefault()
    let newColor = $(evt.currentTarget).attr('data-color');
    let oldColor = $('#drawnShapeColor .selected-color-inner').attr('data-color')
    if (newColor === oldColor) {
      return;
    }
    $('#drawnShapeColor .selected-color-inner').attr('data-color',newColor)
    $('#drawnShapeColor .selected-color-inner').css('background', newColor)
    this.toggleColorSelection(evt)
    let condition = $('#drawnShapeCondition').val()
    this.changeAnnotationColor(newColor, condition)
    window.dispatchEvent(new CustomEvent('drawnShapeColorChanged', {
      detail: {
        newColor: newColor,
        oldColor: oldColor,
        targetShape: condition
      }
    }));
  }

  changeName(evt) {
    evt.preventDefault()
    let newName = $('#drawnShapeName').val().trim()
    let condition = $('#drawnShapeCondition').val()

    if (newName === '') {
      $('#drawnShapeName').val($('#drawnShapeName').attr('data-original-name'))
      return;
    } else if (newName === $('#drawnShapeName').attr('data-original-name')) {
      return;
    }
    $('#drawnShapeName').attr('data-original-name',newName)
    this.changeAnnotationName(newName, condition)
    window.dispatchEvent(new CustomEvent('drawnShapeNameChanged', {
      detail: {
        newName: newName,
        oldName: $('#drawnShapeName').attr('data-original-name'),
        targetShape: condition
      }
    }));
    $('#drawnShapeName').attr('data-original-name', newName)
  }

  editShape(evt) {
    evt.preventDefault()

    let condition = $('#drawnShapeCondition').val()

    // Tell whoever needs to know that we want to edit the desired shape
    $('#drawnShapeManagementMenu').css({ display: 'none'});
    $('#colorChoices').addClass('hidden');
    window.dispatchEvent(new CustomEvent('drawnShapeStartEdit', {
      detail: {
        targetShape: condition
      }
    }));
  }

  changeAnnotationName(newName, condition) {
    // Make a copy of annotations so the state's actual annotations value
    // doesn't change until we call setState.
    var annotations = JSON.parse(JSON.stringify(getState('annotations')));

    let changeHappened = false
    annotations.forEach(a => {
      if (a['Type'] === 'Shape' && a['Match']['Substring'] === condition) {
        a['Attributes']['Label'] = newName;

        if(window.nativeAppInterface && typeof window.nativeAppInterface.addShape === 'function') {
          const { quickSearchId, savedSearchId, comparableSearchId } = window.searchResultsData;

          window.nativeAppInterface.replaceShape({
            quickSearchId,
            savedSearchId,
            comparableSearchId,
            shapeId: condition,
            annotation: a,
          });
        }

        changeHappened = true;
      }
    });
    if (changeHappened) {
      setState('annotations', annotations);
      sessionStorage.setItem('annotations',JSON.stringify(annotations))
    }
  }

  changeAnnotationColor(newColor, condition) {
    // Make a copy of annotations so the state's actual annotations value
    // doesn't change until we call setState.
    var annotations = JSON.parse(JSON.stringify(getState('annotations')));

    let changeHappened = false
    annotations.forEach(a => {
      if (a['Type'] === 'Shape' && a['Match']['Substring'] === condition) {
        a['Attributes']['Color'] = newColor.replace('#','');
        
        if(window.nativeAppInterface && typeof window.nativeAppInterface.addShape === 'function') {
          const { quickSearchId, savedSearchId, comparableSearchId } = window.searchResultsData;

          window.nativeAppInterface.replaceShape({
            quickSearchId,
            savedSearchId,
            comparableSearchId,
            shapeId: condition,
            annotation: a,
          });
        }
        
        changeHappened = true;
      }
    });
    if (changeHappened) {
      setState('annotations', annotations);
      sessionStorage.setItem('annotations',JSON.stringify(annotations))
    }
  }

  activateTimeShield(evt) {
    // cancel any shields that are currently happening
    clearTimeout(this.shieldTimeout)

    // Mr Sulu, shields up!
    this.shieldsUp= true

    this.shieldTimeout = setTimeout(() => {
      // Deactivating shields, Captain!
      this.shieldsUp = false
    }, 500)
  }

  addToOverlay(evt) {
    evt.preventDefault()
    let condition = $('#drawnShapeCondition').val()

    $('#drawnShapeManagementMenu').css({ display: 'none'})
    $('#colorChoices').addClass('hidden')
    window.dispatchEvent(new CustomEvent("map:displayOverlayManager", {
      detail: {
        overlayName: null,
        existingOverlayShapes: null,
        publicOverlay: false,
        initialShapeCondition: condition
      }
    }));
  }

}